module.exports = __webpack_public_path__ + "img/close.5d7fd4aa.svg";